function Electrocin () {
    return (
        <div>
            <div className="text-center text-white text-4xl poppins-bold">Coming Soon ...</div>
        </div>
    );
}

export default Electrocin;